import { useContext, useState } from "react";
import { useDispatch } from "react-redux";

import SetAdvisor from "data/advisor/actions";
import useCurrentUser from "data/advisor/useCurrentUser";
import { SetAdvisorPreferences } from "data/libs/advisor";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

function useClientCardMode() {
  const { fireError } = useContext(ToasterContext);
  const [loading, setLoading] = useState(false);
  const user = useCurrentUser();
  const dispatch = useDispatch();

  return {
    showNewClientCard: user.preferences?.showNewClientCard,
    loading: loading,
    toggleClientCardMode: async () => {
      const updatedMode = !user.preferences?.showNewClientCard;
      setLoading(true);
      try {
        await SetAdvisorPreferences(user.id, {
          key: `showNewClientCard`,
          value: updatedMode,
        });

        dispatch(
          SetAdvisor({
            ...user,
            preferences: {
              ...(user.preferences || {}),
              showNewClientCard: updatedMode,
            },
          })
        );
      } catch (error) {
        console.error("Failed to set showNewClientCard preferences:", error);
        fireError("Failed to preserve the client card mode preference.");
      } finally {
        setLoading(false);
      }
    },
  };
}

export default useClientCardMode;
